import type { FC } from 'react';
import { Popconfirm, Space, Tooltip, Typography } from 'antd';
import { Icon } from '@/components/icon';
import { Button } from 'components';

const { Text } = Typography;

export interface TemplateRow {
  id: string;
  name: string;
  updatedAt?: string | null;
  isDefault: boolean;
}

interface Props {
  template: TemplateRow;
  onEdit: (tpl: TemplateRow) => void;
  onDelete: (tpl: TemplateRow) => void;
  onSetDefault: (tpl: TemplateRow) => void;
  disableSetDefault?: boolean;
}

export const TemplateActionButtons: FC<Props> = ({ template, onEdit, onDelete, onSetDefault, disableSetDefault }) => (
  <Space>
    <Tooltip title="Edit template">
      <Button icon={<Icon iconString="edit" />} type="text" onClick={() => onEdit(template)} />
    </Tooltip>

    {!template.isDefault && (
      <Tooltip title="Set as default">
        <Button
          disabled={disableSetDefault}
          icon={<Icon iconString="favourites" />}
          type="text"
          onClick={() => onSetDefault(template)}
        />
      </Tooltip>
    )}

    <Popconfirm
      cancelText="Cancel"
      okText="Confirm"
      okType="danger"
      title={
        <Text>
          Do you want to delete <strong>{template.name}</strong>? This action is irreversible.
        </Text>
      }
      onConfirm={() => onDelete(template)}
    >
      <Tooltip title="Delete template">
        <Button danger icon={<Icon iconString="delete" />} type="text" />
      </Tooltip>
    </Popconfirm>
  </Space>
);
